import React, { useEffect, useState } from "react";
import { useGetNotificationsQuery } from "../../store/api/notificationApi";
import TimeAgoComponent from "../tools/TimeAgoComponent";

export default function NotificationsS() {
  const [notification, setNotifications] = useState([]);
  const { data, refetch } = useGetNotificationsQuery();

  useEffect(() => {
    if (data && Array.isArray(data)) {
      setNotifications(data);
    }
  }, [data]);

 

  useEffect(() => {
    const handleRefresh = () => {
      refetch();
    };
    handleRefresh()
  }, [notification, refetch]);

  

  return (
    <>
      <div className="block-content position-sticky">
        <h2 className="content-heading pb-0 mb-0">Notifications</h2>
      </div>

      <div className="block1">
        <div className="block-content block-content-full">
          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 col-12 overflow-y" >
              {notification?.map((data) => {
                return (
                  <div className="row shadow-md bg-light p-2 mt-3 rounded-2 position-relative">
                    <div className="col-md-2 col-lg-2 col-sm-12 col-xl-2 col-12  d-flex justify-content-center align-items-center text-start">
                      <img
                        className="ps-1 ps-xl-0 w-50 "
                        src={data.image}
                        alt=""
                      />
                    </div>
                    <div className="col-md-10 col-lg-10 col-sm-12 col-xl-10 col-12 mt-3">
                      <div class="position-absolute top-0 end-0 pe-3 d-flex justify-content-center">
                        <div class={data.qty > 0 ? "spinner-grow  text-warning me-1 ": "spinner-grow  text-danger me-1 "} style={{width: '10px', height: '10px'}} role="status">
                          <span class="sr-only ">Loading...</span>
                        </div>
                        <span class="text-muted fw-light">
                          {<TimeAgoComponent givenDate={data.date} />}
                        </span>
                      </div>

                      <div>
                        <h3 className="text-capitalize fw-semibold fs-5 pt-2">
                          {data.name}
                        </h3>
                        <p className="pb-0 mb-0">{data.text}</p>
                        <span className="fs-5 text-muted fw-">quantity </span>
                        {": "}
                        <span className="fs-5 fw-bold text-danger">
                          {data.qty}
                        </span>
                      </div>

                      <div class="position-absolute bottom-0 end-0 pe-3">
                        <span class="text-muted fw-light">
                          {new Date(data.date).toDateString()}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
